const getPrice = (NOMBRE, setQuantity)=> {
    var old = JSON.parse(localStorage.getItem("carrito"))
    var i = 0;
    for (; i < old.length ;){
        if (old[i].desc === NOMBRE){
            setQuantity(old[i].precio * old[i].cant)
        }
        i++
    }
}

export { getPrice }